
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/self-storage-facilities-near-me",
      function () {
        return require("private-next-pages/self-storage-facilities-near-me/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/self-storage-facilities-near-me"])
      });
    }
  